import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle } from "react";
import axios from "axios";
import { useContext } from "react";
import AuthContext from "../context/authContext";
import _ from "lodash";
import {
  Modal,
  Spin,
  message,
  Row,
  Col,
  Space,
  Typography,
} from "antd";
import { Unity } from "react-unity-webgl";
import "../Modals/illus.css";
// import { UnityContext } from "../context/unityContext";



const verbose = true; // set to true to enable debug logging
const vlog = (...args) => verbose && console.log(...args);


const Illusmaker = forwardRef(({
  handleIllusModal,
  illusState,
  isPlayerMode = false,
  sentence,
  handleAddEnrichment,
  sWordSpanID,
  groupId,
  isTransparent,
  setIsSavingEnrichment,
  onEnrichmentsChange,
  sentenceEnrichmentRef,
  sentenceEnrichments,
  setSentenceEnrichments,
  fetchEnrichments,
  fetchAllEnrichments,
  selectedEnrichment,
  setSelectedEnrichment,
  selectedEnrichmentRef,
  onSelectedWordChange,
  onChangeDetected,
  handleSelectedWordButtonClick,
  selectedWordSpanID,
  onEnrichmentSceneLoaded,
  onDeleteEnrichment,
  unityContextValue
}, ref) => {
  const [loading, setLoading] = useState(true);
  // const [sentenceEnrichments, setSentenceEnrichments] = useState([]);
  
  
  const saveInFlightRef = useRef(false);
  const enrichmentLoadInFlightRef = useRef(false);
  const lastLoadedEnrichmentIdRef = useRef(null);
  const handleIsSavingStateRef = useRef(null);
  const handleIsChangeDetectedRef = useRef(null);
  const handleSaveJsonRef = useRef(null);
  const pendingEnrichmentSaveRef = useRef(null);
  const changeDetectedRef = useRef(false);
  const [changeDetectedState, setChangeDetectedState] = useState(false);
  const [isPopConfirmVisible, setPopConfirmVisible] = useState(false);
  const [tempJsonData, setTempJsonData] = useState(null);
  const { currentUser } = useContext(AuthContext);
  // const unityContextValue = UnityContext();
  const { unityProvider, loadingProgression, isLoaded, sendMessage, addEventListener, removeEventListener } = unityContextValue;

  const [showOverlay, setShowOverlay] = useState(true);

  const setUnityMode = () => {
    setShowOverlay(isPlayerMode);
    // sendMessage("Manager_Mode", "SetMode", isPlayerMode ? "true" : "false");
  };
  

  const showMessageInfo = (message_text) => {
    message.info({
      content: (
        <div style={{ fontSize: "20px", fontWeight: "bold" }}>
          {message_text}
        </div>
      ),
      duration: 2, // Stays for 2 seconds
    });
  };

  const showMessageSuccess = (message_text) => {
    message.success({
      content: (
        <div style={{ fontSize: "20px", fontWeight: "bold" }}>
          {message_text}
        </div>
      ),
      duration: 2, // Stays for 2 seconds
    });
  };

  const showMessageError = (message_text) => {
    message.error({
      content: (
        <div style={{ fontSize: "20px", fontWeight: "bold" }}>
          {message_text}
        </div>
      ),
      duration: 2, // Stays for 2 seconds
    });
  };

  const showMessageWarning = (message_text) => {
    message.warning({
      content: (
        <div style={{ fontSize: "20px", fontWeight: "bold" }}>
          {message_text}
        </div>
      ),
      duration: 2, // Stays for 2 seconds
    });
  };

  const normalizeSceneJson = (sceneData) => {
    let normalizedScene = sceneData;

    for (let i = 0; i < 2 && typeof normalizedScene === "string"; i++) {
      normalizedScene = JSON.parse(normalizedScene);
    }

    if (
      !normalizedScene ||
      typeof normalizedScene !== "object" ||
      Array.isArray(normalizedScene)
    ) {
      throw new Error("Scene JSON must be an object.");
    }

    return normalizedScene;
  };

  

  const handleSelectedEnrichedWord = (wordSpanID) => {
    handleSelectedWordButtonClick(wordSpanID);
    setShowOverlay(false);
    onSelectedWordChange?.(wordSpanID);
    vlog("handleSelectedWordButtonClick::useeffect:selectedEnrichmentRef:",selectedEnrichmentRef);
    sendMessage("Manager_Mode", "SetMode", "false");
    setUnityMode();
    vlog("[Illusmaker] Word selected, waiting for selectedEnrichment effect to load scene.");
    window.OnIllusmakerReady = handleIllusMakerReadyState;

  };
  // useEffect(()=>{
  //   // handleSelectedWordButtonClick(selectedWordSpanID);
  //   setSelectedEnrichment(undefined);
  //   console.log("setSelectedEnrichment::useeffect::",selectedEnrichment);
  //   setSelectedWordSpanID(null);
  //   console.log("selectedWordSpanID::useeffect::",selectedWordSpanID);
  // },[isTransparent]);


  useEffect(() => {
    if (isTransparent) { setShowOverlay(true); }
  }, [isTransparent]);

  // const [dynamicAssets, setDynamicAssets] = useState(null);
  
  
  //#region Load assets=====================================================================================================================================
  useEffect(() => {
    if (sentence.storyid) {
      if (isLoaded) {
        setLoading(false);
      }
      fetch(`/api/assets/${sentence.storyid}`)
        .then(response => response.json())
        .then(data => {
          
          vlog("DynamicJson:::", data);
          sendMessage("Manager_Mode", "SetMode", "false");
          setUnityMode();
          window.OnIllusmakerReady = handleIllusMakerReadyState;
          sendMessage("Manager_AssetDB", "LoadAssetsFromJson", JSON.stringify(data));
          vlog("[Illusmaker] Asset DB loaded for sentence:", sentence.storyid);
        })
        .catch(error => console.error('Error loading JSON:', error));
    }
  }, [isLoaded, sentence.storyid]);
//#endregion



//#region Load actors=====================================================================================================================================
  useEffect(() => {
    if (sentence.storyid) {
      fetch(`/api/actors/story/${sentence.storyid}`)
      .then(response => {  
        if (!response.ok) {throw new Error("Failed to load story actors");
        }  
        return response.json();
      })
      .then(data => {  
        vlog("[Illusmaker] Story actors:", JSON.stringify(data.actors || []));  
        sendMessage("Manager_AssetDB","LoadActorsFromJson", JSON.stringify(data.actors || []));  
      })
      .catch(error => {  
        console.error("Error loading story actors:", error);  
      });
    }  
  }, [isLoaded, sentence.storyid]);
//#endregion



  const requestEnrichmentSave = () => {
    if (pendingEnrichmentSaveRef.current) {
      vlog("[Illusmaker] Reusing in-flight enrichment save.");
      return pendingEnrichmentSaveRef.current.promise;
    }

    let resolveSave;
    let rejectSave;
    const promise = new Promise((resolve, reject) => {
      resolveSave = resolve;
      rejectSave = reject;
    });
    const pendingSave = { promise, resolve: resolveSave, reject: rejectSave };
    pendingEnrichmentSaveRef.current = pendingSave;
    vlog("[Illusmaker] Dispatching automatic enrichment save.", {
      sentenceId: sentence?.id,
      wordSpanId: selectedWordSpanID.current,
      isLoaded,
    });
    promise.then(
      () => {
        if (pendingEnrichmentSaveRef.current === pendingSave) {
          pendingEnrichmentSaveRef.current = null;
        }
      },
      () => {
        if (pendingEnrichmentSaveRef.current === pendingSave) {
          pendingEnrichmentSaveRef.current = null;
        }
      }
    );

    setIsSavingEnrichment(true);
    try {
      sendMessage("Manager_SaveLoad", "SaveScreenItems");
      vlog("[Illusmaker] SaveScreenItems dispatched to Unity.");
    } catch (error) {
      console.error("[Illusmaker] Failed to dispatch SaveScreenItems:", error);
      setIsSavingEnrichment(false);
      pendingSave.reject(error);
    }
    return promise;
  };

  const handleIsSavingState = (isSaving) => {
    vlog("[Illusmaker] Unity isSavingEvent received:", isSaving);
    if (isSaving) {
      setIsSavingEnrichment(isSaving);
      vlog("isSaving is started", isSaving);
      if (!pendingEnrichmentSaveRef.current) {
        sendMessage("Manager_SaveLoad", "SaveScreenItems");
      }
      vlog("isSaving SaveScreenItems:before:handleSaveJson:", isSaving);
      vlog("isSaving after:handleSaveJson::", isSaving);
      sendMessage("Manager_Mode", "SetMode", "false");
      setUnityMode();
      window.OnIllusmakerReady = handleIllusMakerReadyState;
    } else{
      showMessageError("Unable to trigger save event in unity.")
    }
  }

  // ref pointing to latest closure so window.isSavingEvent never goes stale
  handleIsSavingStateRef.current = handleIsSavingState;
  handleIsChangeDetectedRef.current = (changeDetected) => {
    const hasChanges =
      changeDetected === true || changeDetected === 1 ||
      changeDetected === "true" || changeDetected === "1";
    vlog("[Illusmaker] Unity IsSceneChanged received:", {
      payload: changeDetected,
      hasChanges,
      sentenceId: sentence?.id,
      wordSpanId: selectedWordSpanID.current,
    });
    changeDetectedRef.current = hasChanges;
    setChangeDetectedState(hasChanges);
    onChangeDetected?.(hasChanges);
    if (hasChanges) {
      vlog("[Illusmaker] Scene is dirty; starting automatic save.");
      requestEnrichmentSave().catch((error) => {
        console.error("Error triggering enrichment save:", error);
      });
    } else {
      vlog("[Illusmaker] Scene is unchanged; automatic save skipped.");
    }
  }
  
  const fetchDataAndSendToUnity = async () => {
    if (selectedEnrichment !== undefined) {
      const enrichmentId = selectedEnrichment?.id;
      if (!enrichmentId) {
        return;
      }
      if (enrichmentLoadInFlightRef.current && lastLoadedEnrichmentIdRef.current === enrichmentId) {
        vlog("[Illusmaker] Skip duplicate load (in-flight):", enrichmentId);
        return;
      }
      if (lastLoadedEnrichmentIdRef.current === enrichmentId) {
        vlog("[Illusmaker] Skip duplicate load (already loaded):", enrichmentId);
        onEnrichmentSceneLoaded?.(enrichmentId);
        return;
      }
      try {
        enrichmentLoadInFlightRef.current = true;
        vlog("[Illusmaker] Loading enrichment:", enrichmentId);
        const response = await axios.get(
          `/api/enrichments/${selectedEnrichment.id}`
        );
        vlog("fetchDataAndSendToUnity:::", response.data);
        const base64Data = response.data?.illusdata_str;
        if (!base64Data) {
          vlog("[Illusmaker] Skip LoadScene: missing illusdata_str for enrichment:", enrichmentId);
          return;
        }
        const jsonData = normalizeSceneJson(base64Data);
        if (!jsonData) {
          vlog("[Illusmaker] Skip LoadScene: parsed scene is empty for enrichment:", enrichmentId);
          return;
        }
        setTempJsonData(jsonData);
        vlog("TempJsonData:::", jsonData);
        // sendMessage("Manager_Mode", "SetMode", "false"); /"true" == playermode / "false" == maker mode
        vlog("[Illusmaker] LoadScene::called");
        sendMessage("Manager_SaveLoad", "LoadScene", JSON.stringify(jsonData));
        lastLoadedEnrichmentIdRef.current = enrichmentId;
      } catch (error) {
        console.error("Error fetching JSON data:", error);
        showMessageError("Die Daten konnten nicht geladen werden.");
      } finally {
        enrichmentLoadInFlightRef.current = false;
        onEnrichmentSceneLoaded?.(enrichmentId);
      }
    } else {
      vlog("[Illusmaker] No selected enrichment for current sentence. Skipping LoadScene.");
      lastLoadedEnrichmentIdRef.current = null;
    }
  };

  /*
  const fetchAssets = async () => {
    try {
      const jsonstoryid = sentence.storyid;
      const response = await axios.get(`/assets/${jsonstoryid}`);
      console.log("Raw response data:", response.data); // Debug log to see exact data

      // Don't parse if already an object
      const assetData = typeof response.data === 'string' 
        ? JSON.parse(response.data) 
        : response.data;
      
      console.log("Processed asset data:", assetData); // Debug log
      sendMessage("AssetLoader", "StartLoadingAssets", JSON.stringify(assetData));
    } catch (error) {
      console.error("Error loading story assets:", error);
      if (error instanceof SyntaxError) {
        console.error("Raw data that failed to parse:", error.message);
      }
    }
  };
  */

  const getEnrichmentBefore = () => {
    vlog("fetchDataAndSendToUnity:::", "No enrichment found");
    const wordPos = parseInt(selectedWordSpanID.current.split("_")[2]);
    for (let i = 0; i <= sentenceEnrichments.length - 1; i++) {
      const enrichment = sentenceEnrichments[i];
      const enrichmentSentenceId = parseInt(
        enrichment.wordspanid.split("_")[1]
      );
      const enrichmentWordPos = parseInt(enrichment.wordspanid.split("_")[2]);

      if (
        enrichmentSentenceId < sentence.id ||
        (enrichmentSentenceId === sentence.id && enrichmentWordPos < wordPos)
      ) {
        vlog("getEnrichmentBefore:::", enrichment);
        return enrichment;
      }
    }

    vlog("No enrichment found in current or previous sentences.");
    return undefined;
  };

  useEffect(() => {
    fetchDataAndSendToUnity();
  }, [selectedEnrichment?.id, sentence?.id]);
  
  useEffect(() => {
    vlog("isPlayerMode changed:", isPlayerMode);
    setUnityMode();
  }, [isPlayerMode, isLoaded]);

  useEffect(() => {
    // if (isLoaded) {
    //   setLoading(false);
    // }
    const handleError = (message) => {
      console.error("Unity Error: ", message);
      showMessageError("Es gab ein Problem beim Laden des Illusmaker.");
    };

    addEventListener("error", handleError);
    //fetchAssets();

    return () => {
      removeEventListener("error", handleError);
    };

  }, [isLoaded, addEventListener, removeEventListener]);

  useEffect(() => {
    // Stable wrappers: always delegate to the latest handler closure via refs.
    // Prevents stale-closure bugs where Unity calls a handler captured before isLoaded=true.
    window.isSavingEvent = (isSaving) => handleIsSavingStateRef.current?.(isSaving);
    window.IsSceneChanged = (changeDetected) => handleIsChangeDetectedRef.current?.(changeDetected);
    window.ReceiveFromJson = (jsonData, imgSrc) => {
      vlog("[Illusmaker] Unity ReceiveFromJson callback invoked.");
      return handleSaveJsonRef.current?.(jsonData, imgSrc);
    };
    return () => {
      delete window.isSavingEvent;
      delete window.IsSceneChanged;
      delete window.ReceiveFromJson;
    };
  }, []);

  const handleDeleteEnrichment = async (enrichment) => {
    vlog(enrichment);
    if (selectedEnrichment !== undefined) {
      vlog("selectedEnrichment:::", selectedEnrichment.wordspanid);
      if (selectedEnrichment.wordspanid === enrichment) {
        const response = await axios.delete(
          `/api/enrichments/${selectedEnrichment.id}`
        );
        if (response.status !== 200) {
          throw new Error("Die Illustration konnte nicht gelöscht werden");
        } else {
          const new_sentenceEnrichments = sentenceEnrichments.filter(
            (enrichment) => enrichment.id !== selectedEnrichment?.id
          );
          setSentenceEnrichments(new_sentenceEnrichments);
          onEnrichmentsChange?.(new_sentenceEnrichments);
          
          // Call the parent callback to refresh all enrichments
          if (onDeleteEnrichment) {
            await onDeleteEnrichment(selectedEnrichment.id);
          }
          if (fetchAllEnrichments) {
            await fetchAllEnrichments();
          }
          
          showMessageSuccess("Illustration erfolgreich gelöscht!");
          vlog(
            "Deleted empty enrichment:::",
            "Deleted enrichment successfully"
          );
        }
      } else {
        showMessageInfo("Es gibt keine Illustration für das ausgewählte Wort.");
      }
    }
  };
  const handleIllusMakerReadyState = () => {
    vlog("Illusmaker is ready.");
  };
  const handleSaveJson = async (jsonData, imgSrc) => {
    // if (saveInFlightRef.current) {
    //   return;
    // }
    vlog("isSaving:inside:handleSaveJson", selectedWordSpanID.current);
    if (selectedWordSpanID.current === null) {
      vlog("inside:handleSaveJson:", selectedWordSpanID.current);
      showMessageWarning("Bitte wähle zuerst ein Wort aus.");
      setIsSavingEnrichment(false);
      pendingEnrichmentSaveRef.current?.reject(
        new Error("Cannot save an enrichment without a selected word.")
      );
      return;
    }
    saveInFlightRef.current = true;
    vlog("[Illusmaker] Unity returned scene JSON for persistence.", {
      sentenceId: sentence?.id,
      wordSpanId: selectedWordSpanID.current,
    });

    try {
      vlog("Img::", imgSrc);
      const normalizedSceneJson = normalizeSceneJson(jsonData);
      const jsonDataStr = JSON.stringify(normalizedSceneJson);

      if (selectedEnrichmentRef.current === undefined) {
        fetchEnrichments();
        vlog("handleSaveJson::sentenceEnrichments:", sentenceEnrichments);
        vlog("[Illusmaker] Current selected sentence ",sentence)
        const enrichment = sentenceEnrichmentRef.current.find(
          (e) => e.wordspanid === selectedWordSpanID.current
        );
        vlog("isSaving:handleSaveJson::enrichment:", enrichment);
        selectedEnrichmentRef.current = enrichment;
        vlog("isSaving:handleSaveJson::selectedEnrichmentRef:", enrichment);
      }

      await handleAddEnrichment(
        sentence,
        selectedWordSpanID.current,
        jsonDataStr,
        selectedEnrichmentRef.current
      );

      fetchEnrichments();
      if (fetchAllEnrichments) {
        await fetchAllEnrichments();
      }
      changeDetectedRef.current = false;
      setChangeDetectedState(false);
      onChangeDetected?.(false);
      pendingEnrichmentSaveRef.current?.resolve();
      vlog("[Illusmaker] Enrichment persistence completed successfully.");
      showMessageSuccess("Erfolgreich gespeichert!");
    } catch (error) {
      pendingEnrichmentSaveRef.current?.reject(error);
      console.error("Error saving enrichment:", error);
      showMessageError("Speichern fehlgeschlagen.");
    } finally {
      saveInFlightRef.current = false;
      setIsSavingEnrichment(false);
    }
  };
  // Always keep ref pointing to latest closure so window.ReceiveFromJson never goes stale
  handleSaveJsonRef.current = handleSaveJson;

  const handleJsonFromUnity = (jsonData) => {
    try {
      const parsedJson = JSON.parse(jsonData);
      vlog("JSON Received from Unity:::", parsedJson);
      const diff = _.isEqual(tempJsonData, parsedJson);

      vlog("Diff:", diff);
      if (!diff) {
        setChangeDetectedState(true);
        vlog("changes detected.");
        setPopConfirmVisible(true);
      } else {
        setChangeDetectedState(false);
        onChangeDetected?.(false);
      }
    } catch (error) {
      console.error("Error parsing Unity JSON:", error);
    }
  };

  useImperativeHandle(ref, () => ({
    handleWordSelect: handleSelectedEnrichedWord,
    saveEnrichment: () => {
      vlog("[Illusmaker] Sentence switch requested an enrichment save.", {
        sentenceId: sentence?.id,
        wordSpanId: selectedWordSpanID.current,
      });
      return requestEnrichmentSave();
    },
    saveEnrichmentIfChanged: () =>
      changeDetectedRef.current ? requestEnrichmentSave() : Promise.resolve(),
    confirmWordChange: () => {
      window.ReceiveFromJson = handleSaveJson;
      fetchDataAndSendToUnity();
    },
    handleDeleteEnrichment: (wordSpanID) => handleDeleteEnrichment(wordSpanID),
  }));

  const showPopConfirm = () => {
    setPopConfirmVisible(true);

  };

  return (
    <>
      <Row style={{ width: "100%", height: "100%", margin: 0 }}>
        <Col span={24} style={{ height: "100%" }}>
          <Spin
            style={{ height: "100%", display: "block" }}
            spinning={loading}
            // tip={
            //   <p style={{ fontSize: "2.5em" }}>
            //     Tippe auf ein Wort, um zu starten!
            //     {/* {Math.round(loadingProgression * 100)}% */}
            //   </p>
            // }
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "100%",

              }}
            >
              {selectedWordSpanID ? (
                <>
                  <Unity
                    unityProvider={unityProvider}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      border: 0,
                      visibility: isLoaded ? "visible" : "hidden",
                    }}
                  />
                  {(isPlayerMode || (showOverlay && loading)) && (
                    <div
                      className={`illusmaker-lock-overlay ${
                        isPlayerMode
                          ? "illusmaker-lock-overlay--player"
                          : "illusmaker-lock-overlay--loading"
                      }`}

                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        color: "#1677ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        //fontSize: "1.2em",
                        zIndex: 10,
                        cursor: "pointer",
                      }}
                    >
                      <Space direction="vertical" size="large" align="center">
                        {isPlayerMode ? (
                          <Typography.Text strong style={{ fontSize: "20px", color: "#1677ff" }}>
                            Illusmaker ist im Player-Modus gesperrt.
                          </Typography.Text>
                        ) : null}
                      </Space>

                    </div>
                  )}
                </>
              ) : (
                <></>
              )}
            </div>
          </Spin>
        </Col>
      </Row>


    </>
  );
});
export default Illusmaker;
